/* @flow */

import React from 'react';
import { Button } from 'semantic-ui-react';

type Props = {
  canOrderUp: boolean,
  canOrderDown: boolean,
  onOrderUp: () => void,
  onOrderDown: () => void,
};

const styles = {
  buttons: {
    margin: 'auto',
  },
};

const BlockOrderButtons = ({
  canOrderUp,
  canOrderDown,
  onOrderUp,
  onOrderDown,
}: Props) => (
  <Button.Group vertical style={styles.buttons}>
    <Button
      type="button"
      onClick={onOrderUp}
      disabled={!canOrderUp}
      compact
      icon="chevron up"
    />
    <Button
      type="button"
      onClick={onOrderDown}
      disabled={!canOrderDown}
      compact
      icon="chevron down"
    />
  </Button.Group>
);

export default BlockOrderButtons;



// WEBPACK FOOTER //
// ./src/modules/edito/components/BlockOrderButtons.js